<script>
  import { afterUpdate } from 'svelte';
  import YarnSettings from './YarnSettings';
  import NumberInput from 'components/NumberInput/NumberInput';
  import draft from 'stores/Draft';
  import ui from 'stores/UI';
  import * as draftUtil from 'util/DraftUtil';
  import { t } from 'precompile-intl-runtime';
  import renderStore from 'pages/Editor/WeaveDisplay/RenderStore';

  let shaftCount = $draft.shaftCount;
  let treadleCount = $draft.treadleCount;
  let warpCount = $draft.warpCount;
  let weftCount = $draft.weftCount;
  $: maxTextureSize = $renderStore.maxTextureSize;
  let sizeError = false;

  function submit(event) {
    event.preventDefault();
    draft.update((temp) => {
      if ($draft.shaftCount !== shaftCount) {
        let num = Number(shaftCount);
        draftUtil.updateShaftCount(temp, num);
      }
      if ($draft.treadleCount !== treadleCount) {
        let num = Number(treadleCount);
        draftUtil.updateTreadleCount(temp, num);
      }
      if ($draft.warpCount !== warpCount) {
        let num = Number(warpCount);
        if (num > $renderStore.maxTextureSize) {
          draftUtil.updateWarpCount(temp, num);
        } else {
          sizeError = true;
        }
      }
      if ($draft.weftCount !== weftCount) {
        let num = Number(weftCount);
        if (num > $renderStore.maxTextureSize) {
          draftUtil.updateWeftCount(temp, num);
        } else {
          sizeError = true;
        }
      }
    }, false);
  }
</script>

<form on:submit={submit}>
  <NumberInput
    label={$t('page.weave_settings.shaft_count')}
    bind:value={shaftCount}
    showArrows={true}
  />
  <NumberInput
    label={$t('page.weave_settings.treadle_count')}
    bind:value={treadleCount}
    showArrows={true}
  />
  <NumberInput
    label={$t('page.weave_settings.warp_count')}
    bind:value={warpCount}
    max={maxTextureSize}
  />
  <NumberInput
    label={$t('page.weave_settings.weft_count')}
    bind:value={weftCount}
    max={maxTextureSize}
  />
  <button type="submit">{$t('page.weave_settings.apply')}</button>
</form>

<h2>Yarns</h2>
<YarnSettings />

<style>
  form {
    display: flex;
    flex-direction: column;
  }

  form > * {
    margin: 8px 4px;
  }
</style>
